import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'mxjl-map',
  name: '服务地图',
  icon: '图',
  group: '新聚浪业务组件',
  description: '展示地图、附近服务点和定位入口。',
  defaultProps: {
    title: '徐州服务地图',
    defaultCity: '徐州',
    centerLatitude: 34.2058,
    centerLongitude: 117.2841,
    zoom: 12,
    showLocation: true,
    showSearch: true,
    emptyText: '地图服务加载中'
  }
}
